/* Beleza2 - Calculadora de frete + barra de frete grátis por região
   Autossuficiente: injeta CSS, HTML e lógica. Usa a API nativa do Shopify
   (/cart/shipping_rates.json) que já retorna as tarifas reais da Frenet. */
(function(){
  if (window.__freteCalcLoaded) return;
  window.__freteCalcLoaded = true;

  var CSS = ''
    + '.frete-calc{border:1px solid #e5e5e5;border-radius:10px;padding:16px;margin:16px 0;font-size:14px;line-height:1.4;background:#fafafa}'
    + '.frete-calc .fc-title{font-weight:600;margin-bottom:10px;font-size:15px}'
    + '.frete-calc .fc-row{display:flex;gap:8px;flex-wrap:wrap}'
    + '.frete-calc .fc-cep{flex:1;min-width:140px;padding:10px 12px;border:1px solid #ccc;border-radius:8px;font-size:15px;background:#fff}'
    + '.frete-calc .fc-cep:focus{outline:none;border-color:#111}'
    + '.frete-calc .fc-btn{padding:10px 18px;border:none;border-radius:8px;background:#111;color:#fff;font-size:14px;font-weight:600;cursor:pointer}'
    + '.frete-calc .fc-btn:disabled{opacity:.6;cursor:default}'
    + '.frete-calc .fc-nao-sei{display:inline-block;margin-top:6px;font-size:12px;color:#666;text-decoration:underline}'
    + '.frete-calc .fc-msg{margin-top:8px;font-size:13px;color:#c0392b;min-height:0}'
    + '.frete-calc .fc-result{margin-top:14px}'
    + '.frete-calc .fc-bar-wrap{margin-bottom:14px}'
    + '.frete-calc .fc-bar-label{font-size:16px;margin-bottom:8px;font-weight:700;text-align:center;line-height:1.3}'
    + '.frete-calc .fc-bar-label .fc-falta{color:#e07b00;font-size:20px;white-space:nowrap}'
    + '.frete-calc .fc-bar-label.fc-free-label{color:#1a9c46;font-size:18px}'
    + '.frete-calc .fc-bar-track{height:18px;background:#ececec;border-radius:9px;overflow:hidden;box-shadow:inset 0 1px 2px rgba(0,0,0,.08)}'
    + '.frete-calc .fc-bar-fill{display:block;height:100%;width:0;border-radius:9px;background:linear-gradient(90deg,#f7b733,#f0a500);transition:width .6s ease}'
    + '.frete-calc .fc-bar-fill.fc-free{background:linear-gradient(90deg,#2ecc71,#1a9c46)}'
    + '.frete-calc .fc-methods{display:flex;flex-direction:column;gap:8px}'
    + '.frete-calc .fc-method{display:flex;justify-content:space-between;align-items:center;padding:10px 12px;border:1px solid #eaeaea;border-radius:8px;background:#fff}'
    + '.frete-calc .fc-m-left{display:flex;flex-direction:column}'
    + '.frete-calc .fc-m-name{font-weight:600}'
    + '.frete-calc .fc-m-prazo{font-size:12.5px;color:#666}'
    + '.frete-calc .fc-m-price{font-weight:700}'
    + '.frete-calc .fc-m-price.fc-gratis{color:#1a9c46}'
    + '.frete-calc .fc-dest{margin-top:10px;font-size:12.5px;color:#666}';

  var HTML = ''
    + '<div class="fc-title">🚚 Calcule o frete e o prazo</div>'
    + '<div class="fc-row">'
    +   '<input id="fcCep" class="fc-cep" type="text" inputmode="numeric" autocomplete="postal-code" maxlength="9" placeholder="Digite seu CEP">'
    +   '<button id="fcBtn" class="fc-btn" type="button">Calcular</button>'
    + '</div>'
    + '<a class="fc-nao-sei" href="https://buscacepinter.correios.com.br/app/endereco/index.php" target="_blank" rel="noopener">Não sei meu CEP</a>'
    + '<div id="fcMsg" class="fc-msg"></div>'
    + '<div id="fcResult" class="fc-result" hidden>'
    +   '<div class="fc-bar-wrap"><div class="fc-bar-label" id="fcBarLabel"></div><div class="fc-bar-track"><div class="fc-bar-fill" id="fcBarFill"></div></div></div>'
    +   '<div id="fcMethods" class="fc-methods"></div>'
    +   '<div id="fcDest" class="fc-dest"></div>'
    + '</div>';

  function cepToUF(cepRaw){
    var d = String(cepRaw).replace(/\D/g,'');
    if(d.length!==8) return null;
    var n = parseInt(d,10);
    var R = [[1000000,19999999,'SP'],[20000000,28999999,'RJ'],[29000000,29999999,'ES'],[30000000,39999999,'MG'],[40000000,48999999,'BA'],[49000000,49999999,'SE'],[50000000,56999999,'PE'],[57000000,57999999,'AL'],[58000000,58999999,'PB'],[59000000,59999999,'RN'],[60000000,63999999,'CE'],[64000000,64999999,'PI'],[65000000,65999999,'MA'],[66000000,68899999,'PA'],[68900000,68999999,'AP'],[69000000,69299999,'AM'],[69300000,69399999,'RR'],[69400000,69899999,'AM'],[69900000,69999999,'AC'],[70000000,72799999,'DF'],[72800000,72999999,'GO'],[73000000,73699999,'DF'],[73700000,76799999,'GO'],[77000000,77999999,'TO'],[78000000,78899999,'MT'],[78900000,78999999,'RO'],[79000000,79999999,'MS'],[80000000,87999999,'PR'],[88000000,89999999,'SC'],[90000000,99999999,'RS']];
    for(var i=0;i<R.length;i++){ if(n>=R[i][0] && n<=R[i][1]) return R[i][2]; }
    return null;
  }
  function threshold(uf){
    if(uf==='SP') return 97;
    if(['DF','ES','GO','MT','MS','MG','PR','RJ','RS','SC','BA'].indexOf(uf)>=0) return 197;
    if(['AC','AL','AM','AP','CE','MA','PA','PB','PE','PI','RN','RO','RR','SE','TO'].indexOf(uf)>=0) return 297;
    return null;
  }
  function brl(v){ return v.toLocaleString('pt-BR',{style:'currency',currency:'BRL'}); }
  function prazoTxt(days){
    if(!days || !days.length) return '';
    var a=+days[0], b=+days[days.length-1];
    var u=function(x){ return x===1 ? '1 dia útil' : x+' dias úteis'; };
    return a===b ? u(a) : (a+' a '+b+' dias úteis');
  }
  function maskCep(v){
    var d=String(v).replace(/\D/g,'').slice(0,8);
    return d.length>5 ? d.slice(0,5)+'-'+d.slice(5) : d;
  }

  function build(mount){
    var ROOT = document.createElement('div');
    ROOT.className = 'frete-calc';
    ROOT.id = 'freteCalc';
    ROOT.innerHTML = HTML;
    mount.appendChild(ROOT);

    var cepEl = ROOT.querySelector('#fcCep'),
        btn   = ROOT.querySelector('#fcBtn'),
        msg   = ROOT.querySelector('#fcMsg'),
        res   = ROOT.querySelector('#fcResult'),
        barLabel = ROOT.querySelector('#fcBarLabel'),
        barFill  = ROOT.querySelector('#fcBarFill'),
        methods  = ROOT.querySelector('#fcMethods'),
        destEl   = ROOT.querySelector('#fcDest');

    cepEl.addEventListener('input', function(){ cepEl.value = maskCep(cepEl.value); msg.textContent=''; });
    cepEl.addEventListener('keydown', function(e){ if(e.key==='Enter'){ e.preventDefault(); run(); } });
    btn.addEventListener('click', run);

    function setBar(total, T, freeByRate){
      var isFree = freeByRate || (T && total>=T);
      barFill.classList.toggle('fc-free', !!isFree);
      barLabel.classList.toggle('fc-free-label', !!isFree);
      if(isFree){
        barLabel.innerHTML = '🎉 Você tem frete grátis!';
        barFill.style.width='100%';
      } else if(T){
        var falta = T-total;
        barLabel.innerHTML = 'Faltam <span class="fc-falta">'+brl(falta)+'</span> para o frete grátis!';
        var ratio = Math.max(0, Math.min(1, total/T));
        var pct = Math.max(30, Math.min(95, Math.pow(ratio,0.6)*100));
        barFill.style.width = pct+'%';
      } else { barLabel.innerHTML=''; barFill.style.width='0'; }
    }

    function renderMethods(rates){
      methods.innerHTML='';
      rates.sort(function(a,b){ return parseFloat(a.price)-parseFloat(b.price); });
      rates.forEach(function(r){
        var p = parseFloat(r.price);
        var row=document.createElement('div'); row.className='fc-method';
        var priceHtml = p===0 ? '<span class="fc-m-price fc-gratis">Grátis</span>' : '<span class="fc-m-price">'+brl(p)+'</span>';
        row.innerHTML='<div class="fc-m-left"><span class="fc-m-name">'+r.name+'</span><span class="fc-m-prazo">'+prazoTxt(r.delivery_days)+'</span></div>'+priceHtml;
        methods.appendChild(row);
      });
    }

    function run(){
      var uf = cepToUF(cepEl.value);
      if(!uf){ msg.textContent='Digite um CEP válido (8 dígitos).'; res.hidden=true; return; }
      var T = threshold(uf);
      msg.textContent=''; btn.disabled=true; btn.textContent='Calculando...';
      var cep = cepEl.value.replace(/\D/g,'');
      try { localStorage.setItem('fc_cep', cep); } catch(e){}
      var total = 0;
      fetch('/cart.js',{headers:{'Accept':'application/json'}})
        .then(function(r){return r.json();})
        .then(function(cart){
          total = cart.total_price/100;
          var url = '/cart/shipping_rates.json?'+new URLSearchParams({'shipping_address[zip]':cep,'shipping_address[country]':'Brazil','shipping_address[province]':uf});
          return fetch(url,{headers:{'Accept':'application/json'}});
        })
        .then(function(resp){ return resp.status===200 ? resp.json() : {shipping_rates:[]}; })
        .then(function(j){
          var rates = j.shipping_rates||[];
          var freeByRate = rates.some(function(r){ return parseFloat(r.price)===0; });
          setBar(total, T, freeByRate);
          if(rates.length){ renderMethods(rates); }
          else { methods.innerHTML='<div class="fc-m-prazo">Não foi possível calcular o frete para este CEP agora. Tente novamente.</div>'; }
          destEl.textContent = 'Enviando para '+uf;
          fetch('https://viacep.com.br/ws/'+cep+'/json/').then(function(r){return r.json();}).then(function(v){
            if(v && v.localidade){ destEl.textContent = 'Enviando para '+v.localidade+' - '+(v.uf||uf); }
          }).catch(function(){});
          res.hidden=false;
        })
        .catch(function(){ msg.textContent='Erro ao calcular o frete. Tente novamente.'; })
        .finally(function(){ btn.disabled=false; btn.textContent='Calcular'; });
    }

    // Auto-calcula se o CEP já foi salvo
    try {
      var saved = localStorage.getItem('fc_cep');
      if(saved && saved.length===8){ cepEl.value = maskCep(saved); run(); }
    } catch(e){}

    // Recalcula após alterações no carrinho (adicionar/mudar quantidade)
    if(!window.__fcFetchHooked){
      window.__fcFetchHooked = true;
      var of = window.fetch;
      window.fetch = function(){
        var u = arguments[0] ? String(arguments[0]) : '';
        var p = of.apply(this, arguments);
        if(/\/cart\/(add|change|update|clear)(\.js|\.json)?/.test(u)){
          p.then(function(){ setTimeout(function(){ if(cepEl.value){ btn.click(); } }, 500); }).catch(function(){});
        }
        return p;
      };
    }
  }

  // Move o botão "Continuar comprando" do topo para o fim do carrinho
  function relocateContinue(){
    try {
      if(document.querySelector('.fc-continue-wrap')) return;
      var links = document.querySelectorAll('a');
      var link = null;
      for(var i=0;i<links.length;i++){
        if(/continuar comprando|continue shopping/i.test(links[i].textContent||'') && links[i].offsetParent!==null){ link=links[i]; break; }
      }
      if(!link) return;
      var anchor = document.querySelector('.main--cart') || document.querySelector('.line-items') || document.querySelector('form[action$="/cart"], form[action*="/cart"]');
      var parent = anchor ? anchor.parentElement : null;
      if(parent){
        var wrap=document.createElement('div'); wrap.className='fc-continue-wrap'; wrap.style.cssText='text-align:center;margin:18px 0';
        wrap.appendChild(link);
        parent.appendChild(wrap);
      }
    } catch(e){}
  }

  function mountWidget(){
    if(document.getElementById('freteCalc')) return true;
    // reaproveita o ponto de montagem do tema, se existir; senão cria um
    var mount = document.getElementById('frete-calc-mount');
    if(!mount){ mount = document.createElement('div'); mount.id='frete-calc-mount'; }
    var placed = false;
    // Beleza2: coloca DEPOIS dos produtos (fim de .cart__items)
    var cartItems = document.querySelector('.cart__items');
    // Barba: coloca DEPOIS dos produtos (após .line-items)
    var lineItems = document.querySelector('.line-items');
    if(cartItems){ cartItems.appendChild(mount); placed = true; }
    else if(lineItems && lineItems.parentElement){ lineItems.parentElement.insertBefore(mount, lineItems.nextSibling); placed = true; }
    else {
      var form = document.querySelector('form[action$="/cart"], form[action*="/cart"]');
      if(form){ form.appendChild(mount); placed = true; }
      else { var ci = document.querySelector('cart-items'); if(ci){ ci.appendChild(mount); placed = true; } }
    }
    if(!placed) return false;
    build(mount);
    relocateContinue();
    return true;
  }

  function init(){
    var style=document.createElement('style'); style.id='fc-style'; style.textContent=CSS;
    document.head.appendChild(style);
    if(!mountWidget()){
      var tries=0;
      var iv=setInterval(function(){ tries++; if(mountWidget() || tries>20){ clearInterval(iv); } }, 300);
    }
  }

  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();
